// G3 · Journée d'exploitation : « aujourd'hui » commence à l'heure paramétrée (défaut 5 h) — à 00 h 45 on est encore sur la veille.
import { tenantParts } from './tenantTime';
const pad = (n) => String(n).padStart(2, '0');
export const DEFAULT_BUSINESS_DAY_START = 5;
export const localIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const businessTodayDate = (startHour = DEFAULT_BUSINESS_DAY_START, now = new Date()) => {
  const h = Number.isFinite(Number(startHour)) ? Number(startHour) : DEFAULT_BUSINESS_DAY_START;
  // 01.4 · date civile et heure lues dans le fuseau de l'établissement
  const p = tenantParts(now);
  const d = new Date(p.y, p.m - 1, p.d, 12);
  if (p.h < h) d.setDate(d.getDate() - 1);
  d.setHours(12, 0, 0, 0);
  return d;
};
export const businessTodayIso = (startHour, now) => localIso(businessTodayDate(startHour, now));
